import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
`;

export const Subtitle = styled.h2`
  font-size: 20px;
  font-weight: 500;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
`;
